import React, {Component} from 'react';
import {Container} from "@material-ui/core";
import BackComponent from "../../components/BackComponent";
import TaskFormComponent from "../../components/Task/TaskFormComponent";
import {connect} from 'react-redux';
import {addtask} from "../../actions/taskActions";
import {getAllUsers} from "../../actions/userActions";
import {getAllCustomers} from "../../actions/customerActions";
import moment from "moment";
import Swal from 'sweetalert2';
import {Redirect, Link} from "react-router-dom";
import {addbilling} from "../../actions/billingActions";
import BillingFormComponent from "../../components/Billing/BillingFormComponent";

const mapStateToProps = (state) => {
    return {
        getAllUsers: state.users.getAllUsers ? state.users.getAllUsers : JSON.parse(localStorage.getItem('allUsers')),
        getAllCustomers: state.customers.getAllCustomers ? state.customers.getAllCustomers : JSON.parse(localStorage.getItem('allCustomers')),
        getResponDataBilling: state.billings.getResponDataBilling,
        errorResponDataBilling: state.billings.errorResponDataBilling,

    };
};

 class CreateBillingContainer extends Component {

     componentDidMount() {
         this.props.dispatch(getAllUsers());
         this.props.dispatch(getAllCustomers());
     }

    handleSubmit(data){
        data.date = new Date(data.date).toISOString();

        if(data.user_id){
            data.user_id = data.user_id?.value;
        }

     {this.props.getAllUsers.map((user) => {
         if(user._id == data.user_id){
             data.user_firstname = user.firstname ? user.firstname : '';
             data.user_lastname = user.lastname ? user.lastname : '';
         }
            }
        )}

        if(data.customer_id){
            data.customer_id = data.customer_id?.value;
        }
        {this.props.getAllCustomers.map((customer) => {
            if(customer._id == data.customer_id){
                data.customer_firstname = customer.firstname ? customer.firstname : '';
                data.customer_lastname = customer.lastname ? customer.lastname : '';
            }
            }
        )}
        this.props.dispatch(addbilling(data))
        let newData = data;
        if(newData.billing_status === "paye"){
            newData.date = moment(newData.date).add(1, 'M');
            newData.billing_status = "en_attente";
            this.props.dispatch(addbilling(newData))
        }
    }

     render() {
         if(this.props.getResponDataBilling || this.props.errorResponDataBilling) {
             if (this.props.errorResponDataBilling) {
                 Swal.fire(
                     "Echec ! ",
                     this.props.errorResponDataBilling,
                     "error"
                 );
             } else {

                 Swal.fire({
                     title: "Facturation créee !",
                     icon :"success",
                     showCloseButton: true,
                 }).then((result) => {
                     if (result.isConfirmed) {
                         window.history.back();
                     }
                 });
             }
         }
         return (
            <Container>
                <BackComponent />
                <h1>Crée une facturation</h1>
                <BillingFormComponent onSubmit={(data) => this.handleSubmit(data)}/>
            </Container>
        )
    }
}

export default connect(mapStateToProps,null)(CreateBillingContainer)